import { render } from "./HeaderLogo.vue?vue&type=template&id=352e4826&scoped=true"
const script = {}

import "./HeaderLogo.vue?vue&type=style&index=0&id=352e4826&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352e4826"]])

export default __exports__